module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Media/Media-library#2-4abfee8942d217b51918cabdd2e15992.svg";